/* eslint-disable react-refresh/only-export-components */
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
import { Navigate } from 'react-router';
import { lazy } from 'react';
const Dealer = lazy(() => import('@/modules/main/dealer/AddCarriersToDealer'));
const DocumentApprovals = lazy(
  () =>
    import('@/modules/main/carrier/document-approvals/DocumentApprovalsList'),
);
const AddCustomer = lazy(
  () => import('@/modules/main/customer/add/AddCustomer'),
);
const EditCustomer = lazy(
  () => import('@/modules/main/customer/edit/EditCustomer'),
);
const ListCustomers = lazy(
  () => import('@/modules/main/customer/list/ListCustomers'),
);
const ViewCustomers = lazy(
  () => import('@/modules/main/customer/view/ViewCustomers'),
);

const AddNewCarrier = lazy(
  () => import('@/modules/main/carrier/add/AddCarrier'),
);
const EditCarrier = lazy(
  () => import('@/modules/main/carrier/edit/EditCarrier'),
);
const ListCarriers = lazy(
  () => import('@/modules/main/carrier/list/ListCarrier'),
);
const ViewCarrier = lazy(
  () => import('@/modules/main/carrier/view/ViewCarrier'),
);
const Dashboard = lazy(() => import('@/modules/main/dashboard/Dashboard'));

export const mainNavRoutes = [
  {
    path: 'dashboard',
    element: withSuspense(Dashboard),
  },
  {
    path: 'dealer-uploads',
    element: withSuspense(Dealer),
  },
  {
    path: 'carriers',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'add',
        element: withSuspense(AddNewCarrier),
      },
      {
        path: 'list',
        element: withSuspense(ListCarriers),
      },
      {
        path: ':id/edit',
        element: withSuspense(EditCarrier),
      },
      {
        path: ':id/view',
        element: withSuspense(ViewCarrier),
      },
      {
        path: 'approve-documents',
        element: withSuspense(DocumentApprovals),
      },
    ],
  },
  {
    path: 'customers',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'add',
        element: withSuspense(AddCustomer),
      },
      {
        path: 'list',
        element: withSuspense(ListCustomers),
      },
      {
        path: ':id/edit',
        element: withSuspense(EditCustomer),
      },
      {
        path: ':id/view',
        element: withSuspense(ViewCustomers),
      },
    ],
  },
];
